export default {"src":"/_next/static/media/left-quote.b691509c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};